module.exports = __webpack_public_path__ + "img/close.8d58bbc3.png";